import {useState} from 'react';
import {Badge, Button} from '@mantine/core';
import {FiFilter} from 'react-icons/fi';
import {FilterDrawer} from '../drawers/FilterDrawer';
import {useReconciliationReportsChannel} from '../hooks/useReconciliationReports';

// FNP-607: standard Filter button + drawer (replaces the inline ChannelSelector),
// matching the Customers / Billing Providers FilterRecordsButton exactly: an
// absolutely-positioned blue count Badge as the active-filter notification. A channel
// filter is ALWAYS applied here (it defaults to STRIPE and is required, non-clearable),
// so the badge always shows — count is always 1 (the channel). This is the "default
// filter is selected, so show the notification" behaviour the owner asked for.
export const FilterRecordsButton = () => {
    const [opened, setOpened] = useState(false);
    const {channel} = useReconciliationReportsChannel();

    // Exactly one filter is always active (the required channel).
    const activeCount = channel ? 1 : 0;

    return (
        <>
            <div style={{position: 'relative'}}>
                <Button
                    variant="outline"
                    leftSection={<FiFilter size={16}/>}
                    onClick={() => setOpened(true)}
                >
                    Filter
                </Button>
                {activeCount > 0 && (
                    <Badge
                        size="xs"
                        variant="filled"
                        color="blue"
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                    >
                        {activeCount}
                    </Badge>
                )}
            </div>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
